





















import {
    Component, mapState, mixins,
} from '@samclick-commons';
import { Payload, UpdateinfoStore } from '@samclick-store-factory';
import SamclickMixins from '@/utils/mixins';
import UpdateInformationTab from '@/views/UpdateInformationTab.vue';
import UpdatePaymentTab from '@/views/UpdatePaymentTab.vue';
import UpdatePostbackTab from '@/views/UpdatePostbackTab.vue';

class UpdateInformationState {
    activeTab: string = 'detail'
}

@Component({
    /**
   * Imported components
   * */
    components: { UpdateInformationTab, UpdatePaymentTab, UpdatePostbackTab },
    /**
   * Stores values
   * */
    computed: {
        ...mapState({
            loading: (state: any) => state.updateinfo.updateinfoStore.loading,
            isPostbackFeatureEnabled: (state: any) => state.updateinfo.updateinfoStore.isPostbackFeatureEnabled,
        }),
    },
    /**
   * Component properties
   * */
    props: {},
})
export default class UpdateInformation extends mixins(SamclickMixins) {
    state = new UpdateInformationState();

    isPostbackFeatureEnabled!: boolean;

    fetchAffiliateBetaFeatures() {
        UpdateinfoStore.getAffiliateBetaFeatures(new Payload({
            storeData: true,
        })).then(() => {
            if (!this.isPostbackFeatureEnabled && this.state.activeTab === 'postback') {
                this.state.activeTab = 'detail';
            }
        });
    }

    created() {
        const tab = this.$route.query.tab;
        if (typeof tab === 'string' && ['detail', 'paymentAccount', 'postback'].indexOf(tab) > -1) {
            this.state.activeTab = tab;
        }

        this.fetchAffiliateBetaFeatures();
    }
}
